import { all } from 'redux-saga/effects';

import decoratedOpportunitySaga from './decorated-opportunity';
import groupsSaga from './groups';
import initialDataSaga from './initial-application-data';
import notificationsSaga from './notifications';
import usersSaga from './users';

export default function* rootSaga() {
  yield all([
    decoratedOpportunitySaga(),
    groupsSaga(),
    initialDataSaga(),
    notificationsSaga(),
    usersSaga(),
  ]);
}
